import { api } from "shared/redux/api"
import { objectToQueryString } from "shared/utils/common"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLeaveType: build.query({
      query: () => ({
        url: "/private/leave-type",
      }),
    }),
    getLeaveTypes: build.query({
      query: () => ({
        url: "/private/leave/v1/types",
      }),
    }),
    getLeaveRequest: build.query({
      query: (arg = {}) => ({
        url: `/private/leave-request?${objectToQueryString(arg)}`,
      }),
    }),
    createLeaveRequest: build.mutation({
      query: (data = {}) => ({
        url: "/private/leave/v1",
        method: "POST",
        body: data,
      }),
    }),
    updateLeaveRequest: build.mutation({
      query: (id, data) => ({
        url: `/private/leave-request/${id}`,
        method: "PUT",
        body: data,
      }),
    }),
    approveLeaveRequest: build.mutation({
      query: (id) => ({
        url: `/private/leave-request/${id}/approve`,
        method: "POST",
      }),
    }),
    rejectLeaveRequest: build.mutation({
      query: (id) => ({
        url: `/private/leave-request/${id}/reject`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetLeaveTypeQuery,
  useLazyGetLeaveTypesQuery,
  useLazyGetLeaveRequestQuery,
  useCreateLeaveRequestMutation,
} = injectedRtkApi
